import { useAsyncExecutor2 } from "async-executor-hook";
import { format } from "date-fns";
import { useEffect } from "react";
import {
  FormControl,
  FormGroup,
  useFormConfig,
  Validators,
  WForm,
  WFormControl,
} from "rectangular-forms";
import { from } from "rxjs";

import {
  inputMaxLengthFn,
  WInputTextArea,
} from "../../../common/components/TemplateContainer/InputTemplates";
import { TemplateInputContainer } from "../../../common/components/TemplateContainer/TemplateContainer";
import LoadingSpinner from "../../../images/icon_loading_green.gif";
import { HTTP_METHODS } from "../../../utils/constants";
import { networkBackendRequest } from "../../../utils/networkUtils";
import { ApproveButton } from "../../AdminDocumentManagement/AdminDocumentManagementSharedStyles";
import Modal from "../../Modal/Modal";
import { Container } from "./modalConfimationStyles";

export const ConfirmationModal = (props) => {
  const {
    toggleModal,
    onSuccessData,
    haveBalance,
    sidebarInfo,
    dataFomr,
    onErrorData,
  } = props;

  const asyncExecutor = useAsyncExecutor2(
    (comment: any) => {
      const elem = comment.sidebarInfo;
      const newStatus = comment.status;

      const upfront_manual_payment_details = comment.dataFomr.operations.map(
        (operation) => {
          const dateOperation = new Date(operation.payment_date);
          const date = format(dateOperation, "yyyy-MM-dd");
          return {
            voucher_id: operation.id,
            operation_number: operation.line.numeroOperacion,
            amount: +operation.montoDeposito,
            operation_number_voucher: operation.operation_number_voucher,
            payment_date: date,
          };
        }
      );
      return from(
        networkBackendRequest(
          `/invoices/upfront-manual/${elem.invoiceId}/`,
          HTTP_METHODS.PATCH,
          null,
          {
            cashback_comment: comment.comment,
            upfront_manual_payment_details,
            payment_status_option: newStatus,
            invoice_rejected_comment: newStatus === "rejected" ? comment : null,
          }
        ).then((resp) => resp.json())
      );
    },
    {
      onSuccess: (_, params) => {
        onSuccessData({ params });
      },
      onError: (err) => {
        onErrorData(err);
      },
    }
  );

  const formConfig = useFormConfig({
    createForm: (data) => {
      const form = new FormGroup({
        comment: new FormControl(null, Validators.maxLength(300)),
      });
      form.patchValue(data);
      return form;
    },
    onSubmit: (form) => {
      asyncExecutor.execute({
        comment: form.value.comment,
        sidebarInfo,
        status: "paid",
        dataFomr,
      });
    },
  });

  const { loadSucceed } = formConfig;

  useEffect(() => {
    loadSucceed({ comment: "" });
  }, [loadSucceed]);

  return (
    <Modal
      onOutsideClick={() => {
        toggleModal();
      }}
    >
      <Container haveBalance={haveBalance}>
        <h1>Confirmación de aprobación</h1>
        <h2>
          {haveBalance
            ? "Se tiene un saldo a favor (+)"
            : "Se tiene un saldo en contra (-)"}
        </h2>

        <label htmlFor="test" style={{ marginTop: "1.5rem" }}>
          El pago será aprobado al momento de la confirmación.
        </label>
        {haveBalance && (
          <label htmlFor="abc">
            Luego de realizar la aprobación de este pago se enlazará el Nº de
            Operación con este saldo a favor.
          </label>
        )}
        <div style={{ width: "100%" }}>
          <WForm formConfig={formConfig} style={{ width: "100%" }}>
            <WFormControl name="comment">
              <TemplateInputContainer
                color="rgba(46, 53, 61, 0.3)"
                marginBottom="0px"
                label={
                  haveBalance ? "Comentario:" : "Comentario para aprobación:"
                }
              >
                <WInputTextArea
                  maxWidth="37rem"
                  maxheight="15rem"
                  width="100%"
                  height="13.8rem"
                  placeholder="Escribe el motivo de aprobación"
                  rows={5}
                  cols={30}
                  maxLength={300}
                  onInput={inputMaxLengthFn}
                />
              </TemplateInputContainer>
            </WFormControl>
            <div style={{ marginTop: "2.8rem", width: "100%" }}>
              <ApproveButton
                type="submit"
                width="100%"
                disabled={asyncExecutor.isLoading}
              >
                {asyncExecutor.isLoading && (
                  <img
                    className="icon"
                    style={{ width: "4rem", height: "4rem" }}
                    src={LoadingSpinner}
                    alt="spinner"
                  />
                )}
                Aprobar pago
              </ApproveButton>
            </div>
          </WForm>
        </div>
      </Container>
    </Modal>
  );
};
